import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Card, Input, Button } from '@getpay93/ui';
import { api } from '../lib/api';

function strength(pw: string): { label: string; color: string } {
  if (pw.length < 8) return { label: 'Muy corta', color: 'var(--status-overdue)' };
  if (pw.length < 12) return { label: 'Aceptable', color: 'var(--status-pending)' };
  return { label: 'Fuerte', color: 'var(--brand-green)' };
}

export function RecuperarReset() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const nav = useNavigate();
  const [pw, setPw] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const s = strength(pw);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.auth.resetPassword(token, pw);
      nav('/login', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'El enlace es inválido o expiró');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="gp-light" style={{ minHeight: '100vh', background: 'var(--bg)', display: 'grid', placeItems: 'center', padding: 24 }}>
      <Card style={{ width: '100%', maxWidth: 400 }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, color: 'var(--text-strong)', marginTop: 0 }}>Nueva contraseña</h1>
        {!token ? (
          <p style={{ color: 'var(--status-overdue)' }}>Falta el token. Abre el enlace de tu correo.</p>
        ) : (
          <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Input placeholder="Nueva contraseña" type="password" value={pw} onChange={(e) => setPw(e.currentTarget.value)} required />
            {pw ? <span style={{ fontSize: 12, fontWeight: 700, color: s.color }}>{s.label}</span> : null}
            {error ? <p style={{ margin: 0, color: 'var(--status-overdue)', fontSize: 13, fontWeight: 600 }}>{error}</p> : null}
            <Button type="submit" fullWidth disabled={busy || pw.length < 8}>{busy ? 'Guardando…' : 'Cambiar contraseña'}</Button>
          </form>
        )}
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13 }}><Link to="/login">Volver</Link></p>
      </Card>
    </div>
  );
}
